//http://facebook.github.io/fixed-data-table/
import React from 'react';
import BaseReactComponent from '../../Util/BaseReactComponent';
import styles from './ProductsTable.scss';
import baseComponent from '../../../decorators/baseComponent';
import DataTable from '../../DataTable';

@baseComponent(styles) class ProductsTable extends BaseReactComponent {

  addNewProduct() {
    this.props.onAddNew();
  }

  onEditProduct(product) {
    this.props.onEditProduct(product);
  }

  render() {
    return (
      <DataTable rows={this.props.rows} cols={['productID', 'name', 'edit']} onAddNew={this.addNewProduct.bind(this)} onEdit={this.onEditProduct.bind(this)}/>
    );
  }
}

ProductsTable.propTypes = {
  rows: React.PropTypes.array,
  onAddNew: React.PropTypes.func,
  onEditProduct: React.PropTypes.func
};

export default ProductsTable;



// WEBPACK FOOTER //
// /src/components/Product/ProductsTable/ProductsTable.js